import { IsNotEmpty, IsString } from 'class-validator';

export class NotificationMessagesDto {
  @IsNotEmpty()
  @IsString()
  singleSuccess: string;

  @IsNotEmpty()
  @IsString()
  singleError: string;

  @IsNotEmpty()
  @IsString()
  multipleSuccess: string;

  @IsNotEmpty()
  @IsString()
  multipleError: string;
}
